import { useState, useCallback, useEffect } from 'react';
import { Form, InputGroup, FormControl } from 'react-bootstrap';
import cn from 'classnames';
import styles from 'widget/event_components/ticket-spot.scss';
import getSymbolFromCurrency from 'currency-symbol-map';

export const validatePrice = (value, ticket) => {
  const numberPattern = /^(\d+(\.\d{1,2})?)?$/;
  if (!numberPattern.test(value)) {
    return 'Please enter a valid price';
  }
  const parsedValue = parseFloat(value);
  if (parsedValue < ticket.get('minimum_price')) {
    return `Must be a minimum of ${ticket.get('minimum_price')}`;
  }
  return null; // Indicates no error
};

export const PayWhatYouWantInput = ({ errors, settings, ticket, event, handleTicketOverride }) => {
  const [value, setValue] = useState();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (errors && errors.payWhatYouWantError) {
      const errorMessage = validatePrice(value, ticket);
      setError(errorMessage);
    }
  }, [errors, value, ticket]);

  const handleBlur = useCallback(() => {
    const errorMessage = validatePrice(value, ticket);
    setError(errorMessage);
    if (!errorMessage) {
      handleTicketOverride(ticket.get('id'), parseFloat(value));
    }
  }, [value, ticket, handleTicketOverride]);

  return (
    <>
      <Form.Label className="pay-what-you-want-text">{settings.get('payWhatYouWantText')}</Form.Label>
      <Form.Group className={cn('mb-4', styles.payWhatYouWantInput)} controlId="formBasicEmail">
        <InputGroup>
          <InputGroup.Text id="basic-addon1">{getSymbolFromCurrency(event.get('currency'))}</InputGroup.Text>
          <FormControl
            min={!!ticket.get('minimum_price') && ticket.get('minimum_price')}
            onChange={(e) => setValue(e.target.value)}
            onBlur={handleBlur}
          />
        </InputGroup>

        {(error || errors.payWhatYouWantError) && <div className={styles.errorPayWhatYouWantDetails}>{error}</div>}
      </Form.Group>
    </>
  );
};
